import { BUCKETS_AVAILABLE } from '@groww-tech-pvt/web-storage';

import { CONSTANTS } from './storageConstants';

export const identifyBucket = (key: string) => {
  let bucket;

  switch (key) {
    case CONSTANTS.USER_UUID:

    case CONSTANTS.TRADING_VIEW_PREFERENCE:

    case CONSTANTS.USER_INDICES_ORDER:

    case CONSTANTS.UI_THEME:
      bucket = BUCKETS_AVAILABLE.PERSISTED;

      break;

    case CONSTANTS.AUTH_SESSION_ID:

    case CONSTANTS.AUTHORIZATION:

    case CONSTANTS.PIN_TOKEN:

    case CONSTANTS.N_KEY_SEED:

    case CONSTANTS.SOCKET_TOKEN:

    case CONSTANTS.TWO_FACTOR_PIN_ALREADY_SET:
      bucket = BUCKETS_AVAILABLE.AUTH;
      break;

    default:
      bucket = BUCKETS_AVAILABLE.OTHERS;
  }

  return bucket;
};
